import React from 'react'
import { Lazyload } from '~/components'
import * as st from '~/assets/styl/Dimas.module.styl'
import img1 from '~/assets/img/Floripa.jpg'
import img2 from '~/assets/img/Mulher-costas.jpg'
import { useLanguage } from '~/hooks'

export default function Dimas() {
  const { t } = useLanguage()
  return (
    <section className={st.core} id="Diferenciais">
      <div>
        <p>
          <span>
            {t('Dimas.history')}
            <br />
            <br />
            {t('Dimas.aSearch')}
            <br />
            <br />
            {t('Dimas.ourName')}
            <br />
            {t('Dimas.ourDna')}
            <br />
            {t('Dimas.ourWay')}
          </span>
        </p>
        <Lazyload src={img2} className={st.img} />
      </div>
      <Lazyload src={img1}>
        <h2>
          {t('Dimas.wayDimas')}
          <br />
          {t('Dimas.toBe')}
        </h2>
      </Lazyload>
    </section>
  )
}
